import { Tooltip, TooltipContent, TooltipTrigger } from '@goaltree/ui/components/tooltip'
import type { ReactElement } from 'react'
import { useSyncExternalStore } from 'react'

const query = () => window.matchMedia('(hover: hover) and (pointer: fine)')
function useFinePointer() {
  return useSyncExternalStore(
    (cb) => {
      const mq = query()
      mq.addEventListener('change', cb)
      return () => mq.removeEventListener('change', cb)
    },
    () => query().matches,
    () => false,
  )
}

// A tooltip for mouse users only; touch gets none. The child is the trigger, so no wrapper.
export function IconTip({
  label,
  side = 'bottom',
  children,
}: {
  label: string
  side?: 'top' | 'bottom'
  children: ReactElement
}) {
  const fine = useFinePointer()
  if (!fine) return children
  return (
    <Tooltip>
      <TooltipTrigger render={children} />
      <TooltipContent side={side}>{label}</TooltipContent>
    </Tooltip>
  )
}
